import { useState, useEffect } from "react";
import GYAxios from "./GYAxios";

const usePeakLabels = (country) => {
	const [peakLabels, setPeakLabels] = useState(["", ""]);

	useEffect(() => {
		const currentCountry = country;
		if (currentCountry != null && currentCountry != "") {
			const peakLabelReq = GYAxios.get(`/site/peak-label/${currentCountry}`);

			peakLabelReq.then((res) => {
				const peakLabelRes = !res.data.error ? res.data[0] : null;

				if (peakLabelRes != null) {
					const labels = Object.values(peakLabelRes);
					setPeakLabels(labels);
				}
			});
		}
	}, [country]);

	return peakLabels;
};

export default usePeakLabels;
